
const getMainDepartamentOfRP = (residentialPlanEntity) => {

  //Given a residential plan, determines which is the main department
  try {

    if(  !residentialPlanEntity 
      || !residentialPlanEntity.sharedFireDepartments 
      || !residentialPlanEntity.fireDepartmentIdentifier
      ||  residentialPlanEntity.sharedFireDepartments.length < 1 ) {

      console.error('no residential plan info!' );
      return '';
      
    }

    const sharedFireDepartments = residentialPlanEntity.sharedFireDepartments;
    const mainDepartmentIdentifier = residentialPlanEntity.fireDepartmentIdentifier;
    
    const mainDepartment = sharedFireDepartments
    .find( department =>  department.fireDepartmentIdentifier === mainDepartmentIdentifier);

    return mainDepartment.fireDepartmentName; 
    
  } catch (error) {

    console.error(error);
    return '';
    
  }

}

export {getMainDepartamentOfRP}